import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import ProductPageHero from "components/products/ProductPageHero.js";
import MainFeature from "components/features/TwoColWithButton.js";
import Features from "components/features/ThreeColSimple.js";
import ProductScreenshotGallery from "components/products/ProductScreenshotGallery.js";
import ProductLegalLinks from "components/products/ProductLegalLinks.js";
// import Testimonial from "components/testimonials/SimplePrimaryBackground.js";
import GetStarted from "components/cta/GetStarted";
import Footer from "components/footers/FiveColumnWithBackground.js";

import OnboardingWelcome from "images/products/mind-aspirant/onboarding/step-1-welcome.png";
import OnboardingCategories from "images/products/mind-aspirant/onboarding/step-2-categories.png";
import OnboardingQuiz from "images/products/mind-aspirant/onboarding/step-3-quiz.png";
import OnboardingPrizes from "images/products/mind-aspirant/onboarding/step-4-prizes.png";
import FastIcon from "images/fast-icon.svg";
import CelebrationIcon from "images/celebration-icon.svg";
import ShieldIcon from "images/shield-icon.svg";
// import MindAspirantGaurav from "images/mind-aspirant-gaurav.jpeg";

const Subheading = tw.span`uppercase tracking-wider text-sm`;
const WEBSITE_URL = "https://mindaspirant.com";

const onboardingScreens = [
  { src: OnboardingWelcome, alt: "Welcome to Mind Aspirants", caption: "Welcome" },
  { src: OnboardingCategories, alt: "Select quiz categories", caption: "Pick categories" },
  { src: OnboardingQuiz, alt: "Play timed quizzes", caption: "Play the quiz" },
  { src: OnboardingPrizes, alt: "Win prize money", caption: "Win prizes" },
];

const legalLinks = [
  { label: "Privacy Policy", href: "/products/mind-aspirant/privacy-policy" },
  { label: "Terms of Service", href: "/products/mind-aspirant/terms" },
  // { label: "Refund Policy", href: "/products/mind-aspirant/refund-policy" },
  // { label: "DLT SMS Consent", href: "/legal/dlt-sms-consent" },
];

// const gauravTestimonial = [
//   {
//     customerName: "Gaurav Chaudhary",
//     customerProfile: "Founder, Mind Aspirants",
//     imageSrc: MindAspirantGaurav,
//     quote:
//       "We've worked with Spurnest for over 8 months on Mind Aspirants, and their team has been outstanding. They're technically strong, user-friendly in their approach, and genuinely invested in our product's success.",
//   },
// ];

export default () => {
  return (
    <AnimationRevealPage>
      <ProductPageHero
        badge="Game & Education"
        title="Mind Aspirants"
        tagline="Play quiz. Test knowledge. Win prizes. A gamified learning platform where students compete in timed quizzes and climb the leaderboard."
        heroImage={OnboardingWelcome}
        primaryCtaText="Visit Website"
        primaryCtaUrl={WEBSITE_URL}
        secondaryCtaText="How It Works"
        secondaryCtaUrl="#onboarding"
      />
      <MainFeature
        subheading={<Subheading>Overview</Subheading>}
        heading="Direct Our Jackpot."
        showImage={false}
        description="Mind Aspirants is a gamified quiz platform built by Spurnest Techlabs for an Ahmedabad-based ed-tech startup. Users pick categories, compete in live timed quizzes, earn points, and win real prize money — all through an engaging mobile experience."
      />
      <div id="onboarding">
        <ProductScreenshotGallery
          heading="Getting Started"
          description="A simple four-step onboarding flow — welcome, pick your categories, play quizzes, and win prizes."
          screenshots={onboardingScreens}
          variant="phone"
        />
      </div>
      <Features
        subheading={<Subheading>Features</Subheading>}
        heading="Built for competitive learners."
        cards={[
          { imageSrc: FastIcon, title: "Live Quizzes", description: "Timed multiple-choice quizzes with real-time countdown and level progress." },
          { imageSrc: CelebrationIcon, title: "Prize Breakout", description: "Transparent rank-based prize distribution tables showing winnings per position." },
          { imageSrc: ShieldIcon, title: "Leaderboard & History", description: "Track wins, points, completed games, and your standing on the leaderboard." },
        ]}
        linkText=""
      />
      {/* <Testimonial
        subheading="Client Story"
        heading="What the Founder Says"
        description="Mind Aspirants was built end-to-end by the Spurnest team."
        testimonials={gauravTestimonial}
      /> */}
      <ProductLegalLinks productName="Mind Aspirants" links={legalLinks} />
      <GetStarted
        text="Ready to try Mind Aspirants?"
        primaryLinkText="Visit Mind Aspirants"
        primaryLinkUrl={WEBSITE_URL}
        secondaryLinkText="Contact Spurnest"
        secondaryLinkUrl="/contact-us"
      />
      <Footer />
    </AnimationRevealPage>
  );
};
